'use client';
import { config } from '@/configs/configPortal';
import { useRouter } from 'next/navigation';

import './back-button.component.scss';

export default function BackButton() {
    const router = useRouter();
    const currentUrl = config.urlTableFipe;

    const handleBackButtonClick = () => {
        router.push(currentUrl);
    };
    return (
        <button data-testid="btn__back" id="btn__back" className="back-button" onClick={handleBackButtonClick}>
            Voltar para a página inicial
        </button>
    );
}
